


function whichTransitionEvent() {
    var t,
        el = document.createElement("fakeelement");

    var transitions = {
        "transition": "transitionend",
        "OTransition": "oTransitionEnd",
        "MozTransition": "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
    }

    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
}

var transitionEvent = whichTransitionEvent();


$('.mobnav').prependTo('body')

$(".btnmenu").click(function () {

    $('.mobnav').show();
    $('.mobnav').removeClass("opened");
    $('.mobnav .circle2').one(transitionEvent,
        function (event) {
            $('.mobnav').addClass("opened");
        }
    );
    setTimeout(function () {
        $('.mobnav').addClass("open");
    }, 100)


});

$(".btnmenuclose button").click(function () {
    $('.mobnav .circle1').one(transitionEvent,
        function (event) {
            $('.mobnav').removeClass("opened");
            $('.mobnav').hide();
        }
    );
    $('.mobnav').removeClass("open");
});


// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/menu-mobile.js